import { Capacitor } from '@capacitor/core';

/**
 * Platform detection utilities for cross-platform functionality
 */

export type Platform = 'web' | 'ios' | 'android';

/**
 * Get the current platform the app is running on
 */
export function getPlatform(): Platform {
  const platform = Capacitor.getPlatform();
  if (platform === 'ios') return 'ios';
  if (platform === 'android') return 'android';
  return 'web';
}

/**
 * Check if running as a native app (iOS or Android)
 */
export function isNative(): boolean {
  return Capacitor.isNativePlatform();
}

/**
 * Check if running on iOS
 */
export function isIOS(): boolean {
  return Capacitor.getPlatform() === 'ios';
}

/**
 * Check if running on Android
 */
export function isAndroid(): boolean {
  return Capacitor.getPlatform() === 'android';
}

/**
 * Check if running on web
 */
export function isWeb(): boolean {
  return Capacitor.getPlatform() === 'web';
}

/**
 * Check if the app can be installed as a PWA
 */
export function canInstallPWA(): boolean {
  return 'serviceWorker' in navigator && isWeb();
}

/**
 * Check if running in standalone mode (installed PWA)
 */
export function isStandalone(): boolean {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    (window.navigator as unknown as { standalone?: boolean }).standalone === true
  );
}


